import React from 'react';
import { useTranslation } from '@wix/wix-i18n-config';

export const useInitialStepsLabels = () => {
  const { t } = useTranslation();
  const initialSteps: string[] = [
    t('app.template-page.modal.self-hosted.step1'),
    t('app.template-page.modal.self-hosted.step2'),
    t('app.template-page.modal.self-hosted.step3'),
  ];
  return initialSteps;
};

export const LoggedInUserRegex = /^(.*;)?\s*wixClient\s*=\s*[^;]+(.*)?$/;

export const BASE_URL_PROTOCOL = 'https://';
